export const SAVE_GOAL_NAMES = {
	Simple: 'Simple',
	Comfortable: 'Comfortable',
	Lavish: 'Lavish',
	Others: 'Others',
};

export const SAVE_GOAL_LABELS = {
	[SAVE_GOAL_NAMES.Simple]: 'If you save conservatively',
	[SAVE_GOAL_NAMES.Comfortable]: 'If you save moderately',
	[SAVE_GOAL_NAMES.Lavish]: 'If you save aggressively',
	[SAVE_GOAL_NAMES.Others]: 'Add a custom amount',
};

// add a custom object to the list using this
export const CUSTOM_AMOUNT_ADD_OBJ = {
	name: SAVE_GOAL_NAMES.Others,
	corpus: '',
	label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Others],
	dataAid: "custom"
};

export const GOAL_IMAGE_MAPPER = {
	[SAVE_GOAL_NAMES.Simple]: "money_market_conservative.svg",
	[SAVE_GOAL_NAMES.Comfortable]: "money_market_aggresive.svg",
	[SAVE_GOAL_NAMES.Lavish]: "money_market_moderate.svg",
	[SAVE_GOAL_NAMES.Others]: "money_market_custom.svg",
};

export const SAVE_GOAL_MAPPER = {
	retirement: [
		{
			name: SAVE_GOAL_NAMES.Simple,
			corpus: 10000000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Simple],
		},
		{
			name: SAVE_GOAL_NAMES.Comfortable,
			corpus: 20000000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Comfortable],
		},
		{
			name: SAVE_GOAL_NAMES.Lavish,
			corpus: 50000000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Lavish],
		},
	],
	childeducation: [
		{
			name: SAVE_GOAL_NAMES.Simple,
			corpus: 400000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Simple],
		},
		{
			name: SAVE_GOAL_NAMES.Comfortable,
			corpus: 1000000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Comfortable],
		},
		{
			name: SAVE_GOAL_NAMES.Lavish,
			corpus: 3000000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Lavish],
		},
	],
	childwedding: [
		{
			name: SAVE_GOAL_NAMES.Simple,
			corpus: 600000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Simple],
		},
		{
			name: SAVE_GOAL_NAMES.Comfortable,
			corpus: 1500000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Comfortable],
		},
		{
			name: SAVE_GOAL_NAMES.Lavish,
			corpus: 3000000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Lavish],
		},
	],
	vacation: [
		{
			name: SAVE_GOAL_NAMES.Simple,
			corpus: 50000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Simple],
		},
		{
			name: SAVE_GOAL_NAMES.Comfortable,
			corpus: 200000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Comfortable],
		},
		{
			name: SAVE_GOAL_NAMES.Lavish,
			corpus: 500000,
			label: SAVE_GOAL_LABELS[SAVE_GOAL_NAMES.Lavish],
		},
	],
};

export const CUSTOM_GOAL_TARGET_MAPPER = {
    retirement: 20000000,
    childeducation: 1000000,
    childwedding: 1500000,
    vacation: 200000,
    other: 20000000
};
